// extracted by mini-css-extract-plugin
module.exports = {"popup":"PopupWheel_popup__4ivsk","wrapper":"PopupWheel_wrapper__BOwtn","close":"PopupWheel_close__ZNbXU","popupContainer":"PopupWheel_popupContainer__u8sOT"};